document.addEventListener("DOMContentLoaded", function () {
  const section = document.getElementById('main-cart-section');

  section.addEventListener('input', (event) => {
    if(event.target.id === 'cart-submit-confirm-checkbox') {
      const submit = document.getElementById('cart-submit-confirm-submit');
      submit.disabled = !event.target.checked;
      if(event.target.checked) {
        submit.classList.remove('disabled')
      }
      else {
        submit.classList.add('disabled')
      }
    }
  });
  section.addEventListener('click', (event) => {
    if(event.target.id === 'cart-submit-confirm-submit-cover') {
      alert('同意事項に同意していただかなければ、注文はできません。');
    }
  });
});
